import React, { createContext, useContext, useState, useEffect } from 'react'
import { objectToCamelCase, objectToSnakeCase } from './object_case_helpers'

const SessionDataContext = createContext()

const SessionDataContextProvider = props => {
  let data = window.sessionDataService?.get() || JSON.parse(document.querySelector('#session-data')?.innerHTML || 'null') || {}
  const [sessionData, setSessionData] = useState(objectToCamelCase(data))

  const onSessionDataUpdated = data => setSessionData(objectToCamelCase(JSON.parse(data)))

  useEffect(() => {
    window.sessionDataService && window.sessionDataService.bind('sessionDataUpdated', onSessionDataUpdated)

    return () => window.sessionDataService && window.sessionDataService.unbind('sessionDataUpdated', onSessionDataUpdated)
  }, [setSessionData])

  return (
    <SessionDataContext.Provider
      children={props.children}
      value={sessionData}
    />
  )
}

const useSession = () => {
  const sessionData = useContext(SessionDataContext)
  return ([
    // sessionData
    sessionData,
    // setSessionData
    data => window.sessionDataService.set(JSON.stringify(objectToSnakeCase(data)))
  ])
}

export { SessionDataContext, SessionDataContextProvider, useSession }
